import { NGXLogger } from 'ngx-logger';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/app.settings';
import Helper from 'src/app/core/utility/helper';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { ProposalEstimate } from '../../../models/proposal-estimate';
import { ProposalService } from 'src/app/services/proposal.service';
import { Constants } from 'src/app/core/constants';

@Component({
    selector: 'app-estimate-details',
    templateUrl: './estimate-details.component.html',
    styleUrls: ['./estimate-details.component.scss'],
})
export class EstimateDetailsComponent extends BasePage implements OnInit {
    @Input() showCloseWindowButton: boolean = true;
    @Input() parentPage: string;
    @Input() currentEstimateId: string;
    IsEmployee: boolean;
    IsLoggedInAsSupplier: boolean;
    IsEmployee$: Observable<boolean>;
    EstimateId: string;
    EstimateDTOList: ProposalEstimate[];
    EstimatePrimaryLevelDTO: ProposalEstimate;
    selectedTabIndex: number = 0;
    uomSystemId: number = 1;
    estimateMaxLevelDTO: ProposalEstimate;
    pipe = new DatePipe('en-US');
    primaryArray = [];
    secondaryArray = [];
    tertiaryArray = [];

    constructor(
        appSettings: AppSettings,
        logger: NGXLogger,
        localstorageService: LocalstorageService,
        private proposalService: ProposalService,
        private readonly route: ActivatedRoute,
        private dataService: DataService
    ) {
        super(localstorageService, logger, appSettings);
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.EstimateId = this.currentEstimateId != undefined ? this.currentEstimateId : params.get('id');
            if (this.EstimateId) {
                this.getEstimate(this.EstimateId);
            }
        });
    }

    /**
     *  TMS-14254 Flag to PE when new submitted Estimate for an existing part does not match the last approved Estimate
     */
    getEstimate(id: string) {
        if (!this.EstimateDTOList) {
            this.dataService.getEstimate(id).subscribe((response: any) => {
                this.EstimateDTOList = response.Data;
                this.uomSystemId = this.EstimateDTOList.find(x => x.PackageLevelId == 1).UOMSystemId as number;
                this.estimateMaxLevelDTO =  this.EstimateDTOList.find(x => x.PackageLevelId == this.EstimateDTOList.length);
                this.EstimatePrimaryLevelDTO = this.EstimateDTOList[0];
                if(this.currentEstimateId != undefined)
                    this.proposalService.RefreshProposalEstimate(this.EstimateDTOList);
            });
        }
    }

    removeQuotes(rejectionComment: string) {
        const latestRejectionComment =
            Helper.latestRejectionComment(rejectionComment);
        return latestRejectionComment === undefined
            ? ''
            : latestRejectionComment;
    }

    getEffectivityFrom(dto: ProposalEstimate) {
        if (dto) {
            return Helper.formatDate(dto.EffectiveFrom);
        } else {
            return '';
        }
    }

    getStackability(dto: ProposalEstimate) {
        if (dto) {
            return dto.IsStackable ? "Yes" : "No";
        } else {
            return "No";
        }
    }
    
    getDimensionUOMName() {
        return this.uomSystemId == Constants.IMPERIAL_UOM_ID ?  "inches": 'mm'; 
    }
    getWeightUOMName() {
        return this.uomSystemId == Constants.IMPERIAL_UOM_ID ?  "lb": 'kg'; 
    }
}
